<app-navbar
  *ngIf="isAuthenticated"
  (signOutEmitter)="signOut()"
  [email]="email"
  [user]="user"
  [isAuthenticated]="isAuthenticated"
>
</app-navbar>

<div
  style="
    padding: 20px 20px 40px 20px;
    font-family: monospace;
    height: calc(100vh - 60px);
    overflow-y: auto;
  "
>
  <div style="margin-bottom: 40px">
    <h1 style="color: white; font-weight: bold; margin-bottom: 10px">
      {{ applicationName }}
    </h1>
    <p *ngIf="applicationUrl" style="color: #999; font-size: 1.1rem; margin: 0">
      {{ applicationUrl }}
    </p>
  </div>

  <div style="margin-bottom: 30px" *ngIf="applicationId">
    <h2 style="color: #d11f7a; margin-bottom: 15px">Application Token</h2>
    <p *ngIf="applicationTokenLoading" style="color: #999; font-size: 1rem">
      Minting token...
    </p>
    <div
      *ngIf="applicationTokenError && !applicationTokenLoading"
      style="
        background: #4a1a1a;
        padding: 15px;
        border-radius: 5px;
        border: 1px solid #d11f7a;
      "
    >
      <p style="color: #ff6b6b; margin: 0; font-size: 1rem">
        {{ applicationTokenError }}
      </p>
    </div>
    <div
      *ngIf="
        applicationToken && !applicationTokenLoading && !applicationTokenError
      "
    >
      <div style="background: #333; padding: 15px; border-radius: 5px">
        <pre style="color: white; margin: 10px 0; white-space: pre-wrap">{{
          applicationToken | json
        }}</pre>
      </div>
      <p style="color: #999; margin-top: 10px; font-size: 0.9rem">
        Audience: {{ applicationTokenMeta?.audience }} | Expires:
        {{ applicationTokenMeta?.expiresAt }} | Lifetime:
        {{ applicationTokenMeta?.expiresIn }}s
      </p>
      <div
        *ngIf="applicationTokenVerifying"
        style="
          margin-top: 10px;
          padding: 10px;
          background: var(--token-warning-bg);
          border-radius: 5px;
        "
      >
        <p
          style="
            color: var(--token-warning-color);
            margin: 0;
            font-size: 0.9rem;
          "
        >
          ⏳ Verifying token signature with JWKS...
        </p>
      </div>
      <div
        *ngIf="!applicationTokenVerifying && applicationTokenVerified"
        style="
          margin-top: 10px;
          padding: 10px;
          background: var(--token-success-bg);
          border-radius: 5px;
          border: 1px solid var(--token-success-color);
        "
      >
        <p
          style="
            color: var(--token-success-color);
            margin: 0;
            font-size: 0.9rem;
          "
        >
          ✓ Token signature verified successfully with JWKS
        </p>
      </div>
      <div
        *ngIf="!applicationTokenVerifying && applicationTokenVerified === false"
        style="
          margin-top: 10px;
          padding: 10px;
          background: var(--token-error-bg);
          border-radius: 5px;
          border: 1px solid var(--token-error-color);
        "
      >
        <p
          style="color: var(--token-error-color); margin: 0; font-size: 0.9rem"
        >
          ✗ Token verification failed
        </p>
      </div>
    </div>
  </div>

  <div style="margin-bottom: 30px">
    <h2 style="color: #d11f7a; margin-bottom: 15px">Access Token</h2>
    <div style="background: #333; padding: 15px; border-radius: 5px">
      <pre style="color: white; margin: 10px 0; white-space: pre-wrap">{{
        accessToken?.payload | json
      }}</pre>
    </div>
  </div>

  <div style="margin-bottom: 30px">
    <h2 style="color: #d11f7a; margin-bottom: 15px">ID Token</h2>
    <div style="background: #333; padding: 15px; border-radius: 5px">
      <pre style="color: white; margin: 10px 0; white-space: pre-wrap">{{
        idToken?.payload | json
      }}</pre>
    </div>
  </div>
</div>
